import { TweenMax, TimelineMax } from 'gsap';
import { header_fix } from './header_fix.js';

export function under_op(timeline, wh) {
	var getDevice = (function(){
		var ua = navigator.userAgent;
		if(ua.indexOf('iPhone') > 0 || ua.indexOf('iPod') > 0 || ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0){
			return 'sp';
		}else if(ua.indexOf('iPad') > 0 || ua.indexOf('Android') > 0){
			return 'tab';
		}else{
			return 'other';
		}
	})();
    //TweenMax.set("#op_stage", {x:-wh});
    TweenMax.set("header.general", { alpha:0, y:-60});
    function sf_t(){
        TweenMax.to("#black_lay", 0.4, { x : + 25 + "%", onComplete:sf_t_2 });
        //timeline.to("#op_stage", 0.4,{x:0, onComplete:sf_t_2});
    };
    function sf_t_2(){
        TweenMax.to(".c-scroll-down", 0.6, { alpha:1, left:'0px' });
        TweenMax.fromTo('header.general', 0.6, {alpha:0,  y:-60}, {alpha:1,  y:0});
        TweenMax.to(".under #op_base div.catche", 0.8, {top: '0px' });
        TweenMax.to(".under #op_base div.catche p", 0.8, { alpha:1 });
		//document.body.classList.add("ready");
    }
    header_fix();

    let items = [];
    let base =  getDevice == 'sp' ? 100 : 180;
    const load_grid = document.getElementById('load_grid');
  	let bit_ww = load_grid.clientWidth; 
	  let bit_wh = load_grid.clientHeight;
	  let col = Math.floor(bit_ww / base);
	  let remainder = bit_ww % base;
	  let tile = base + remainder / col;
	  let row = Math.ceil(bit_wh / tile);
	  let len = col * row;
	  let div = '<div class="item"></div>';
	  for (var e = 0; e < len; e++) items.push(div);
  	let selector = items.join('');
  	load_grid.insertAdjacentHTML('afterbegin',selector);
	  let item_tgt = document.querySelectorAll(".item");
		for(let i = 0; i < item_tgt.length; i++) {
	  	item_tgt[i].style.width = tile + 'px'; 
		  item_tgt[i].style.height = tile + 'px'; 
	  }
    var myNodeList = load_grid.getElementsByTagName("div");
    var myArray = Array.prototype.slice.call(myNodeList);
    var sortz = myArray.sort(function(){ return Math.random() - Math.random(); });

    timeline.staggerTo(sortz , 0.35 , {opacity:0} , 0.015);
    timeline.to("#white_lay", 0.4,{x:-wh, onComplete:sf_t});
}